import HTMLReactParser from "html-react-parser";
import React from "react";
import UniqNeedsBG from "../../FindAMentor/img/unique-needs-bg.jpg";
import Unique1 from "./img/unique-need-1.png";
import Unique2 from "./img/unique-need-2.png";
import Unique3 from "./img/unique-need-3.png";
import Unique4 from "./img/unique-need-4.png";
import Unique5 from "./img/unique-need-5.png";

export default function FindAMentorMobile(props) {
  const keyData = props.data || [];
  return (
    <div>
      <section
        style={{
          background: UniqNeedsBG,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="unique-mobile"
      >
        <div class="w-100 pt-50 pb-50 position-relative">
          <div class="container">
            <div class="row">
              <div class="sec-title text-center w-100 position-relative">
                <h2 class="mb-0">Find a Mentor for Your Unique Needs</h2>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-md-1 col-sm-6 col-lg-1"></div>
              <div class="col-md-2 col-sm-6 col-lg-2">
                <div class="unique-sec">
                  <img src={Unique1} />
                  <br />
                  <a class="unique-heading">{keyData[0].Heading}</a>
                  {HTMLReactParser(keyData[0].Text)}
                </div>
              </div>
              <div class="col-md-2 col-sm-6 col-lg-2">
                <div class="unique-sec">
                  <img src={Unique2} />
                  <br />
                  <a class="unique-heading">{keyData[1].Heading}</a>
                  {HTMLReactParser(keyData[1].Text)}
                </div>
              </div>
              <div class="col-md-2 col-sm-6 col-lg-2">
                <div class="unique-sec">
                  <img src={Unique3} /> <br />
                  <a class="unique-heading">{keyData[2].Heading}</a>
                  {HTMLReactParser(keyData[2].Text)}
                </div>
              </div>
              <div class="col-md-2 col-sm-6 col-lg-2">
                <div class="unique-sec">
                  <img src={Unique4} />
                  <br />
                  <a class="unique-heading">{keyData[3].Heading}</a>
                  {HTMLReactParser(keyData[3].Text)}
                </div>
              </div>
              <div class="col-md-2 col-sm-6 col-lg-2">
                <div class="unique-sec">
                  <img src={Unique5} />
                  <br />
                  <a class="unique-heading">{keyData[4].Heading}</a>
                  {HTMLReactParser(keyData[4].Text)}
                </div>
              </div>
              <div class="col-md-1 col-sm-6 col-lg-1"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
